import { $api } from '@/utils/api'
import { ref } from 'vue'

const bildirimDestekli = typeof Notification !== 'undefined'
const destekleniyor = ref('serviceWorker' in navigator && 'PushManager' in window && bildirimDestekli)
const aboneDurumu = ref(false)
const abonelik = ref(null)
const izinDurumu = ref(bildirimDestekli ? Notification.permission : 'denied')

export function useWebPush() {
  async function servisWorkerKayit() {
    if (!destekleniyor.value) return
    try {
      const kayit = await navigator.serviceWorker.register('/sw.js')

      await abonelikKontrol()
    } catch (hata) {
      console.error('Service Worker kaydı başarısız:', hata)
    }
  }

  async function abonelikKontrol() {
    // FCM için abonelik kontrolü artık backend'den yapılıyor
    // Frontend sadece izin durumunu kontrol ediyor
    if (bildirimDestekli) {
      izinDurumu.value = Notification.permission
      aboneDurumu.value = Notification.permission === 'granted'
    }
  }

  // urlBase64ToUint8Array artık gerekmiyor (FCM kullanıyoruz)

  async function aboneOl() {
    console.log('[useWebPush] aboneOl çağrıldı. Destekleniyor mu:', destekleniyor.value)
    if (!destekleniyor.value) return null
    try {
      console.log('[useWebPush] Firebase import ediliyor...')


      // Firebase messaging import
      const { messaging, getToken } = await import('@/firebase')

      console.log('[useWebPush] Firebase imported. Messaging obj:', messaging)
      
      console.log('[useWebPush] Service Worker ready bekleniyor...')


      // Service Worker kaydını bekle
      const kayit = await navigator.serviceWorker.ready

      console.log('[useWebPush] Service Worker ready. Scope:', kayit.scope)

      console.log('[useWebPush] FCM token isteniyor...')


      // FCM token al
      const fcmToken = await getToken(messaging, {
        serviceWorkerRegistration: kayit,
      })

      console.log('[useWebPush] FCM Token alındı:', fcmToken ? 'Var (uzunluk: ' + fcmToken.length + ')' : 'Yok')

      if (!fcmToken) {
        console.error('[useWebPush] FCM token alınamadı (boş döndü)')
        
        return null
      }
      
      console.log('[useWebPush] Backend abonelik isteği gönderiliyor...')


      // Backend'e gönder
      const response = await $api('/notifications/push/abone-ol', {
        method: 'POST',
        body: {
          fcm_token: fcmToken,
          device_info: navigator.userAgent,
        },
      })

      console.log('[useWebPush] Backend yanıtı:', response)

      aboneDurumu.value = true
      if (bildirimDestekli) {
        izinDurumu.value = Notification.permission
      }

      return fcmToken // Token'ı döndür
    } catch (hata) {
      console.error('[useWebPush] Abonelik başarısız! Hata detayı:', hata)
      
      return null
    }
  }

  async function abonelikIptal() {
    if (!destekleniyor.value) return
    try {
      // FCM için token silme işlemi backend'de yapılıyor
      // Burada sadece state'i temizliyoruz
      aboneDurumu.value = false
      if (bildirimDestekli) {
        izinDurumu.value = Notification.permission
      }

      return true
    } catch (hata) {
      console.error('Abonelik iptali başarısız:', hata)
      
      return false
    }
  }

  return {
    destekleniyor,
    aboneDurumu,
    izinDurumu,
    servisWorkerKayit,
    aboneOl,
    abonelikIptal,
  }
}
